import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map, publishReplay, refCount, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UrlService {
  constructor(
    private router: Router,
    private readonly location: Location,
  ) {}

  public currentUrl$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.urlAfterRedirects),
    startWith(this.location.path()),
    distinctUntilChanged(),
    publishReplay(1),
    refCount(),
  );

  public isSuperAdminRoute$ = this.currentUrl$.pipe(
    map((url) => {
      // On initial load, if we don't look for the embed route param, then the URL will change on us without a
      // route change, and the initial detection of the superadmin state will be wrong.
      const regex = new RegExp('[\\?&]embed=([^&#]*)');
      const results = regex.exec(url);
      const embedRoute = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      url = embedRoute ? embedRoute : url;
      return url.startsWith('/superadmin');
    }),
    distinctUntilChanged(),
    publishReplay(1),
    refCount(),
  );

  public isAutomationsRoute$ = this.currentUrl$.pipe(
    map((url) => {
      // On initial load, if we don't look for the embed route param, then the URL will change on us without a
      // route change, and the initial detection of the superadmin state will be wrong.
      const regex = new RegExp('[\\?&]embed=([^&#]*)');
      const results = regex.exec(url);
      const embedRoute = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      url = embedRoute ? embedRoute : url;
      return url.includes('automations');
    }),
  );
}
